<template>
    <div class="message-wrapper" @click="closeMessage()">
        <div class="message" @click.stop>
            <IconsModalError v-if="isCloseCallbackModalWithError" class="message__status-icon"/>
            <IconsSuccessIcon v-else class="message__status-icon"/>
            <IconsCloseIcon
                class="message__close-icon"
                @click="closeMessage()"
            />

            <div class="message__title">{{ isCloseCallbackModalWithError ? $t("form.messageErrorTitle") : $t("form.messageTitle") }}</div>

            <div class="message__text">
                {{ isCloseCallbackModalWithError ? $t("form.messageErrorText") : $t("form.messageText") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FormMessage",
    props: {
      isCloseCallbackModalWithError: {
        type: Boolean,
        default: false
      }
    },
    methods: {
        closeMessage() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.message-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    background: rgba(70, 70, 70, 0.38);
    display: flex;
    z-index: 500;
}

.message {
    background: #fff;
    position: relative;
    margin: auto;
    padding: 50px;
    text-align: center;
    width: 343px;

    @media (min-width: $screen-m) {
        width: 400px;
    }
}

.message__close-icon {
    position: absolute;
    right: 20px;
    top: 20px;
    margin: 7px;
    cursor: pointer;
}

.message__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 140%;
    text-align: center;
    color: #282828;
    margin: 20px 0 15px;
}

.message__text {
    font-weight: 400;
    font-size: 16px;
    line-height: 152%;
    text-align: center;
    color: #7a7a7a;
}
.message__status-icon {
    width: 35px;
    height: 35px;
    color: #ED1C24;
}
</style>
